'use strict';

wbApp.factory('studentSvc', ['$resource', 'repositorySvc', 'tenantSettingSvc',
    function ($resource, repositorySvc, tenantSettingSvc) {
        var Student = $resource('/Api/Students/:id', {}, {
            'getAll': { method: 'GET', isArray: true, url: '/Api/Students/GetAll' },
            'getCurrent': { method: 'GET', isArray: true, url: '/Api/Students/GetCurrent' },
            'getAllByUserID': { method: 'GET', isArray: true, url: '/Api/Students/GetAllByUserID' },
            'saveAll': { method: 'POST', isArray: true, url: '/Api/Students/SaveCurrent' },
            'insert': { method: 'POST', url: '/Api/Students/Insert' },
            'update': { method: 'POST', url: '/Api/Students/Update' },
            'delete': { method: 'POST', url: '/Api/Students/Delete' },
            'getByID': { method: 'GET', url: '/Api/Students/GetLookupID' },
            'getStudentsWithCompGrpLookupQuery': { method: 'GET', isArray: true, url: '/Api/Students/GetStudentsWithCompGrpLookupQuery' },
            'getStudentsWithCompGrpLookupID': { method: 'GET', url: '/Api/Students/GetStudentsWithCompGrpLookupID' }
        });

        function createNew(user) {

            var nationality;

            if (!!user && user.nationality) {
                nationality = user.nationality;
            } else {
                nationality = tenantSettingSvc.settings.defaultNationality;
            }

            return {
                gender: 'M',
                userID: !!user ? user.id : null,
                isNew: true,
                nationality: nationality
            };
        }

        function getAll() {
            var ret = repositorySvc.customGet('getAll', Student);

            ret.$promise.then(function (data) {
                _.forEach(data, function (student) {
                    student.rfidCardIDsStr = _.join(student.rfidCardIDs, ', ')
                });
            });

            return ret;
        }

        function getStudentsWithCompGrpLookupQuery(query, pageSize, pageNo, semesterID, onSuccess, onError) {
            return repositorySvc.customGet('getStudentsWithCompGrpLookupQuery', Student, {
                query: query,
                pageSize: pageSize,
                pageNo: pageNo,
                semesterID: semesterID
            }, onSuccess, onError);
        }

        function getStudentsWithCompGrpLookupID(studentCompGrpID, semesterID, onSuccess, onError) {
            return repositorySvc.customGet('getStudentsWithCompGrpLookupID', Student, {
                studentCompGrpID: studentCompGrpID,
                semesterID: semesterID
            }, onSuccess, onError);
        }

        function getCurrentAsync() {
            return repositorySvc.customGet('getCurrent', Student);
        }

        function saveAll(data, successCallback, errorCallback) {
            return repositorySvc.saveAll(
                Student,         // $resource
                data,            // entities
                successCallback,
                errorCallback);
        }

        function getByIDAsync(studentId) {
            return repositorySvc.customGet('getByID', Student, { studentID: studentId });
        }

        var byUserID;
        var lasUserID;

        function getAllByUserIDAsync(userID, refresh) {
            if (!byUserID || lasUserID !== userID || refresh) {
                byUserID = repositorySvc.customGet('getAllByUserID', Student, { userID: userID });
                lasUserID = userID;
            }

            return byUserID;
        }

        function insert(data, successCallback, errorCallback, collection) {
            return repositorySvc.insert(
                Student,           // $resource
                collection,          // collection
                data,              // entity
                successCallback,
                errorCallback);
        }

        function update(data, successCallback, errorCallback, collection, disableNotification) {
            return repositorySvc.update(
                Student,           // $resource
                collection,          // collection
                data,              // entity
                successCallback,
                errorCallback,
                'id',
                disableNotification);
        }

        function remove(data, errorCallback, collection) {
            return repositorySvc.remove(
                Student,           // $resource
                collection,          // collection
                data,              // entity
                null,              // successCallback
                errorCallback,
                { studentID: data.id, membershipID: data.membershipID });
        }

        return {
            createNew: createNew,
            getAll: getAll,
            getCurrentAsync: getCurrentAsync,
            getAllByUserIDAsync: getAllByUserIDAsync,
            saveAll: saveAll,
            insert: insert,
            update: update,
            remove: remove,
            getByIDAsync: getByIDAsync,
            getStudentsWithCompGrpLookupQuery: getStudentsWithCompGrpLookupQuery,
            getStudentsWithCompGrpLookupID: getStudentsWithCompGrpLookupID
        }
    }]);